import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  computed,
  onMounted,
  onUnmounted,
  ref,
  unref,
} from 'vue';

import {
  useI18n
} from '@/composables/useI18n';
import {ErrorCodes} from "@/Enums";



export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorDialog',
  props: {
  error: {
    default: {
      message: 'server_error'
    },
    type: [Array, Object, Response, Number, Error, String] as PropType<any[] | Record<any, any> | Response | string>,
  },
},
  emits: [
  'onDialogCancelOrConfirm',
],
  setup(__props, { emit: emits }) {

const props = __props;





const {
  t,
} = useI18n();

const isDialogVisible = ref<boolean>(false);

const statusCodesToHandle = [413];

const translatedMessages = computed(() => {
  const error = unref(props.error);
  if (
    error !== null
    && typeof error === 'object'
    && !Array.isArray(error)
    && error.error
  ) return [error.error];

  const { ErrorCode } = error;
  if(ErrorCode && ErrorCode !== ErrorCodes.unknown){
    return [t(`errorCodes.${ErrorCode}`)];
  }

  const { status } = error;

  return (status && statusCodesToHandle.includes(status))
    ? [t(`statusCodes.${status}`)]
    : [t('server_error'), t('try_again_later')];
})

const onHandleDialogAction = () => {
  isDialogVisible.value = false;
  emits('onDialogCancelOrConfirm');
}

onMounted(() => {
  isDialogVisible.value = true;
});

onUnmounted(() => {
  isDialogVisible.value = false;
})

return { __sfc: true,props, emits, t, isDialogVisible, statusCodesToHandle, translatedMessages, onHandleDialogAction }
}

})